import { Action, createAction, props } from '@ngrx/store';

export const SOLICITUD_DETALLE_COMPLEMENTO_SINIESTRO = '[COMPLEMENTO-WEB] Solicitud DETALLE_COMPLEMENTO_SINIESTRO';
export const OBTENER_RESULT_SELECCIONADO_COMPLEMENTO_SINIESTRO = '[COMPLEMENTO-WEB] Obtener Result SELECCIONADO_COMPLEMENTO_SINIESTRO';
export const ESTABLECER_DETALLE_COMPLEMENTO_SINIESTRO = '[COMPLEMENTO-WEB] Establecer Result DETALLE_COMPLEMENTO_SINIESTRO';


export const SOLICITUD_CATALOGOS_GENERALES = '[COMPLEMENTO-WEB] Solicitud CATALOGOS_GENERALES';
export const OBTENER_RESULT_CATALOGOS_GENERALES = '[COMPLEMENTO-WEB] Obtener Result CATALOGOS_GENERALES';
export const ESTABLECER_CATALOGOS_GENERALES = '[COMPLEMENTO-WEB] Establecer Result CATALOGOS_GENERALES';


export const SOLICITUD_CATALOGOS_TERCERO = '[COMPLEMENTO-WEB] Solicitud CATALOGOS_TERCERO';
export const OBTENER_RESULT_CATALOGOS_TERCERO = '[COMPLEMENTO-WEB] Obtener Result CATALOGOS_TERCERO';
export const ESTABLECER_CATALOGOS_TERCERO = '[COMPLEMENTO-WEB] Establecer Result CATALOGOS_TERCERO';


export const COMPLEMENTO_WEB_FAIL = '[COMPLEMENTO-WEB] Error al ejecutar el servicio';
export const RESET_DETALLE = '[COMPLEMENTO-WEB] Reset detalle complemento';

export const SolicitudDetalleComplementoSVAction = createAction(
    SOLICITUD_DETALLE_COMPLEMENTO_SINIESTRO,
    props<{ formDetalleComplemento: any }>()
);

export const ObtenerResultSiniestroSelccionadoComplementoSVAction = createAction(
    OBTENER_RESULT_SELECCIONADO_COMPLEMENTO_SINIESTRO,
    props<{ detalleComplemento : any }>()
);

export const EstablecerResultDetalleComplementoSVAction = createAction(
    ESTABLECER_DETALLE_COMPLEMENTO_SINIESTRO,
    props<{ detalleComplemento : any }>()
);


export const SolicitudCatalogosDetalleComplementoAction = createAction(
    SOLICITUD_CATALOGOS_GENERALES,
);

export const ObtenerCatalogosDetalleResultComplementoAction = createAction(
    OBTENER_RESULT_CATALOGOS_GENERALES,
    props<{ detalleComplemento : any }>()
);

export const EstablecerCatalogosDetalleResultComplementoAction = createAction(
    ESTABLECER_CATALOGOS_GENERALES,
    props<{ detalleComplemento : any }>()
);


export const SolicitudCatalogosTerceroDetalleComplementoAction = createAction(
    SOLICITUD_CATALOGOS_TERCERO,
);

export const ObtenerCatalogosTerceroDetalleResultComplementoAction = createAction(
    OBTENER_RESULT_CATALOGOS_TERCERO,
    props<{ detalleComplemento : any }>()
);

export const EstablecerCatalogosTerceroDetalleResultComplementoAction = createAction(
    ESTABLECER_CATALOGOS_TERCERO,
    props<{ detalleComplemento : any }>()
);

export const ComplementoWebFailAction = createAction(
    COMPLEMENTO_WEB_FAIL,
    props<{ payload: any }>()
);

export const ResetDetalleComplementoWebAction = createAction(
    RESET_DETALLE
);